import { useEffect } from 'react'
import type { RefObject } from 'react'
import type { DataSheetGridRef } from 'react-datasheet-grid'

// F2 — 엑셀처럼 칸 편집 시작 (그리드는 Enter 로 편집을 시작하므로 Enter 로 바꿔 보낸다). 칸이 선택된 그리드만 받는다
export function useF2Edit(gridRef: RefObject<DataSheetGridRef | null>) {
  useEffect(() => {
    const onKey = (e: KeyboardEvent) => {
      if (e.key !== 'F2' || !gridRef.current?.activeCell) return
      const tag = (document.activeElement as HTMLElement | null)?.tagName
      if (tag === 'INPUT' && document.activeElement?.classList.contains('dsg-input')) return // 이미 편집 중
      e.preventDefault()
      e.stopImmediatePropagation()
      document.dispatchEvent(new KeyboardEvent('keydown', { key: 'Enter', bubbles: true }))
    }
    window.addEventListener('keydown', onKey, true)
    return () => window.removeEventListener('keydown', onKey, true)
  }, [gridRef])
}

/** 표에서 커서를 뺀다 — 표는 칸이 선택돼 있는 동안 문서 전체의 키 입력을 가져가므로, 팝업·서랍의 입력칸에 글자가 가게 하려면 먼저 놓아야 한다.
 *  커서·선택을 돌려놓는 함수를 준다 (표를 눌러 닫았으면 누른 칸 그대로) */
export function releaseGrid(gridRef: RefObject<DataSheetGridRef | null>): () => void {
  const grid = gridRef.current
  const cell = grid?.activeCell
  const sel = grid?.selection
  grid?.setActiveCell(null)
  return () => {
    const g = gridRef.current // 그새 탭을 옮겼으면 이 표는 없다
    if (!g || !cell || g.activeCell) return
    g.setActiveCell({ col: cell.col, row: cell.row })
    if (sel) requestAnimationFrame(() => g.setSelection({ min: { col: sel.min.col, row: sel.min.row }, max: { col: sel.max.col, row: sel.max.row } }))
  }
}
